import {
  PortalBorderOrColor,
  PortalColorSchemas,
  PortalSolidColor,
  PortalTextOrColor,
} from '@nx-frontend/shared/types/portal-colors';
import { ThemeColorSchemas } from '@nx-frontend/shared/types/theme-color-schemas';
import { getThemeColorsBySchema } from './getTheme';

interface SolidColorFromTextColor {
  color: PortalTextOrColor | PortalBorderOrColor;
  themeColors: ThemeColorSchemas;
}

export const getSolidColor = ({ color, themeColors }: SolidColorFromTextColor): PortalSolidColor => {
  if (typeof color !== 'string') {
    return color;
  }
  const themeLight = getThemeColorsBySchema(themeColors, PortalColorSchemas.LIGHT);
  return themeLight[color];
};
